import { useResponsive } from '../../../hooks/useResponsive';
import BenefitsDesktop from './BenefitsDesktop';
import BenefitsMobile from './BenefitsMobile';
import { useBenefits } from './useBenefits';

const Benefits = () => {
  const breakpointIndex = useResponsive([1024]);
  const props = useBenefits();

  if (breakpointIndex === 0) {
    return <BenefitsMobile {...props} />;
  }
  return <BenefitsDesktop {...props} />;
};

export default Benefits;
